import { computed } from 'vue'
import { useSizeDefaults } from 'casc-cesium-composables/private/use-size'

export const useSpinnerProps = {
  size: {
    type: [Number, String],
    default: '1em'
  },
  color: String
}

export default function useSpinner(props) {
  return {
    cSize: computed(() => (props.size in useSizeDefaults ? `${useSizeDefaults[props.size]}px` : props.size)),

    classes: computed(() => 'vc-spinner' + (props.color ? ` text-${props.color}` : ''))
  }
}
